import { ApiService } from './api.service';
import { Account } from '@/models/account';
import { Empty } from '@/models/core/empty';
import { TeacherPasswordReset } from '@/models/teacher/teacher-password-request';
class AccountService extends ApiService {
  constructor() {
    super();
  }

  /**
   * 受検設定一覧集約情報取得
   */
  getAccountProfile(): Promise<Account> {
    return this.get(Account, `/account/profile`, {});
  }

  /**
   * パスワードリセット対象メール
   * @param email
   */
  sendResetPasswordEmail(email: string): Promise<Empty> {
    return this.post(Empty, `/account/sendResetPasswordEmail`, { email: email });
  }

  /**
   * リセット対象メールを取得する
   * @param token
   */
  getResetPasswordEmail(token: string): Promise<TeacherPasswordReset> {
    return this.getWithReject(TeacherPasswordReset, `/account/getEmailByToken?resetPasswordToken=${token}`, {});
  }

  /**
   * パスワードリセット
   * @param password
   * @param token
   */
  resetPassword(password: string, token: string): Promise<Empty> {
    return this.post(Empty, `/account/resetPassword`, { newPassword: password, resetPasswordToken: token });
  }
}

export const accountService = new AccountService();
